import React from "react";
import { Wrapper, HeroButton, CheckList, CheckItem, CheckIcon } from "./styles";
import { FaCheck } from "react-icons/fa";

export default function SolutionsMobile({
  toggleQrModal,
  title,
  subtitle,
  description,
  buttonText,
}) {
  const items = [
    "Apps rápidos e seguros",
    "Design exclusivo com foco em UX/UI",
    "Integração com sistemas internos e APIs",
    "Equipe técnica dedicada do início ao fim do projeto",
  ];
  return (
    <Wrapper>
      <img src="assets/dark/development-image.png" width={"40%"} alt="Imagem representando diferentes funções do celular"/>
      <div className="text-wrapper">
        <div className="Title">{title}</div>
        <div className="DescriptionSubtext">{description}</div>
        <CheckList>
          {items.map((item, idx) => (
            <CheckItem key={idx}>
              <CheckIcon>
                <FaCheck />
              </CheckIcon>
              {item}
            </CheckItem>
          ))}
        </CheckList>{" "}
        <div className="Subtitle">{subtitle}</div>
        {buttonText && (
          <HeroButton onClick={toggleQrModal}>{buttonText}</HeroButton>
        )}
      </div>
    </Wrapper>
  );
}
